<div class="container-fluid d-flex flex-column justify-content-center align-items-center">
  <img src="assets/chapps-logo.png"/>
  <mdb-card id="forgot-password-card" class="m-3">
      <mdb-card-body>
        <h5 appTitle class="text-center mb-4" [translate]="Localization.ResetPassword"></h5>
        <form #form="ngForm">
          <input type="email" id="emailInput" name="emailInput" class="form-control mb-2"
                 [(ngModel)]="model"
                 [disabled]="isProccessing || isResetPasswordRequestSent"
                 [placeholder]="Localization.Email | translate"
                 (keydown.enter)="onSubmit()">
          <div class="importantInfoContainer">
            <h6 [translate]="Localization.ResetPassword_InfoTitle"></h6>
            <p [translate]="Localization.ResetPassword_InfoAlinea1"></p>
            <p [translate]="Localization.ResetPassword_InfoAlinea2"></p>
          </div>
        </form>
        <div *ngIf="isResetPasswordRequestSent" class="alert alert-success mb-0" role="alert"
             [translate]="Localization.ResetPasswordSuccess"></div>
      </mdb-card-body>
      <mdb-card-footer class="text-center">
        <button *ngIf="!isProccessing && !isResetPasswordRequestSent" type="button" class="mb-2"
                data-cy="resetPassword"
                mdbBtn
                appBg="primary"
                brightness="normal"
                appTextColor="primary"
                [block]="true"
                (click)="onSubmit()"
                mdbWavesEffect
                [translate]="Localization.Reset">
        </button>
        <button *ngIf="!isProccessing"
                 data-cy="backButton"
                  class="px-md-0 btn btn-link"
                  (click)="goBack()"
                  [translate]="Localization.Back">
        </button>
        <mdb-spinner *ngIf="isProccessing"></mdb-spinner>
      </mdb-card-footer>
  </mdb-card>
</div>

